/**
 * Component for staff/user E-Mail settings page in the Dashboard.
 *
 * @component
 */

import React from 'react';
import axios from 'axios';
import {
  Button,
  Form,
  Input,
  Checkbox,
  Row,
  Col,
  Divider,
  message,
} from 'antd';
import { PageButtonHeader } from '../../../../components/CustomHeader';

const FormItem = Form.Item;

class EmailAdmin extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      notificationAdminEnabled: undefined,
      notificationErrorEnabled: undefined,
      notificationErrorEmail: undefined,
      notificationAdminEmail: undefined,
      notificationAdminCopyEnabled: undefined,
      notificationAdminCopyEmailAddress: undefined,
      emailReport: undefined,
      trackingChange: {
        newReturnChange: false,
        copyOfCustomerNotificationsChange: false,
        errorNotificationsChange: false,
      },
      loading: true,
    };
  }
  formRef = React.createRef();

  componentDidMount = async () => {
    this.initializeComponent();
  };

  initializeComponent = async () => {
    try {
      await this.fetchEmailSettings();
      this.setState({ loading: false });
    } catch (err) {
      this.setState({ loading: false });
      message.error('Error loading email settings. Please try again.', 4);
    }
  };

  fetchEmailSettings = async () => {
    try {
      const response = await axios.get('/api/emailSettings/admin');
      if (response.data.status === 'error') {
        return message.error(
          'There was an error loading your email settings. Try again.',
          4
        );
      }
      return this.setState({
        ...response.data,
      });
    } catch (err) {
      return message.error(
        'There was an error loading your email settings. Try again.',
        4
      );
    }
  };

  handleSubmit = async () => {
    try {
      const values = await this.formRef.current.validateFields();

      const {
        notificationAdminEnabled,
        notificationAdminEmail,
        notificationErrorEnabled,
        notificationErrorEmail,
      } = this.state;

      if (
        notificationAdminEnabled &&
        (!notificationAdminEmail || notificationAdminEmail === '')
      ) {
        return message.error('Please enter a valid email address.', 4);
      }

      if (
        notificationErrorEnabled &&
        (!notificationErrorEmail || notificationErrorEmail === '')
      ) {
        return message.error('Please enter a valid email address.', 4);
      }

      const response = await axios.post(
        '/api/emailSettings/admin/update',
        values
      );

      if (response.data.status === 'error') {
        return message.error(
          'There was an error saving your email settings. Try again.',
          4
        );
      }

      if (this.state.trackingChange?.newReturnChange) {}

      if (this.state.trackingChange?.copyOfCustomerNotificationsChange) {}

      if (this.state.trackingChange?.errorNotificationsChange) {}

      message.success('E-Mail settings updated successfully.', 4);
    } catch (err) {
      if (err.errorFields) {
        return message.error(
          'Error saving your email settings. Try again.',
          4
        );
      }

      return message.error(
        'There was an error saving your email settings. Try again.',
        4
      );
    }
  };

  onChange = (e) => {
    const target = e.target.id;
    const newReturnChange = [
      'notificationAdminEnabled',
      'notificationAdminEmail',
    ].includes(target);
    const copyOfCustomerNotificationsChange = [
      'notificationAdminCopyEnabled',
      'notificationAdminCopyEmailAddress',
    ].includes(target);
    const errorNotificationsChange = [
      'notificationErrorEnabled',
      'notificationErrorEmail',
    ].includes(target);
    this.setState({
      [target]: e.target.checked,
      trackingChange: {
        ...this.state.trackingChange,
        newReturnChange,
        copyOfCustomerNotificationsChange,
        errorNotificationsChange,
      },
    });
  };

  onChangeEmail = (e) => {
    const target = e.target.id;
    const newReturnChange = [
      'notificationAdminEnabled',
      'notificationAdminEmail',
    ].includes(target);
    const copyOfCustomerNotificationsChange = [
      'notificationAdminCopyEnabled',
      'notificationAdminCopyEmailAddress',
    ].includes(target);
    const errorNotificationsChange = [
      'notificationErrorEnabled',
      'notificationErrorEmail',
    ].includes(target);
    this.setState({
      [target]: e.target.value,
      trackingChange: {
        ...this.state.trackingChange,
        newReturnChange,
        copyOfCustomerNotificationsChange,
        errorNotificationsChange,
      },
    });
  };

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };

    if (this.state.loading) {
      return (
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <div className="GlobalLoader GlobalLoader--md"></div>
        </div>
      );
    }

    return (
      <React.Fragment>
        <Form onFinish={this.handleSubmit} hideRequiredMark={true} ref={this.formRef}>
          <PageButtonHeader headingTitle={'Staff emails'}
           headingRightContent={
            <FormItem>
              <Button type="primary" 
                onClick={this.handleSubmit}
                disabled={this.state.loading}
                loading={this.state.loading}
                style={{ padding: 'var(--input-padding)' }}
                data-intercom-target="header-save-changes-button-notifications-staff-emails">
                Save changes
              </Button>
            </FormItem>
          }
          ></PageButtonHeader>
          <div
            className="flex-row flex-row--noMargin flex-top-xxs flex-between-xxs"
            style={{ gap: 20, width: '100%' }}
          >
            <div
              className="flex-col-md-3 flex-col-sm-12"
              style={{ padding: 0, width: '100%' }}
            >
              <h4 data-intercom-target="return-contact-email-heading-notifications-staff-emails">Return contact email</h4>
              <span>
                Specify the email address for return inquiries. You can override
                the default email if needed.
              </span>
            </div>
            <div
              className="flex-col-md-8 flex-col-sm-12"
              style={{ padding: 0, width: '100%' }}
            >
              <div className="ContentPanel">
                <h4 data-intercom-target="recipient-address-heading-notifications-staff-emails">Recipient address</h4>
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ width: '100%', gap: 10 }}
                >
                  <FormItem {...formItemLayout} name="notificationAdminEmail" initialValue={this.state.notificationAdminEmail}>
                    <Input
                      style={{ width: '100%' }}
                      placeholder="Enter an email address"
                      onChange={this.onChangeEmail.bind(this)}
                      value={this.state.notificationAdminEmail}
                      disabled={
                        this.state && !this.state.notificationAdminEnabled
                      }
                      data-intercom-target="recipient-address-input-notifications-staff-emails"
                    />
                  </FormItem>
                  <FormItem {...formItemLayout} name="notificationAdminEnabled" valuePropName="checked" initialValue={this.state.notificationAdminEnabled}>
                    <Checkbox
                      onChange={this.onChange.bind(this)}
                      data-intercom-target="notification-admin-enabled-checkbox-notifications-staff-emails"
                    >
                      Enable
                    </Checkbox>
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>
          <div
            className="flex-row flex-row--noMargin flex-top-xxs flex-between-xxs"
            style={{ gap: 20, width: '100%' }}
          >
            <div
              className="flex-col-md-3 flex-col-sm-12"
              style={{ padding: 0, width: '100%' }}
            >
              <h4 data-intercom-target="report-recipient-email-heading-notifications-staff-emails">Report recipient email</h4>
              <span>
                Designate the email address to receive all reports and exports.
              </span>
            </div>
            <div
              className="flex-col-md-8 flex-col-sm-12"
              style={{ padding: 0, width: '100%' }}
            >
              <div className="ContentPanel">
                <h4 data-intercom-target="report-recipient-address-heading-notifications-staff-emails">Recipient address</h4>
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ width: '100%' }}
                >
                  <FormItem {...formItemLayout} name="emailReport" initialValue={this.state.emailReport}>
                    <Input
                      style={{ width: '100%' }}
                      placeholder="Enter an email address"
                      onChange={this.onChangeEmail.bind(this)}
                      data-intercom-target="report-recipient-address-input-notifications-staff-emails"
                      value={this.state.emailReport}
                    />
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>
          <div
            className="flex-row flex-row--noMargin flex-top-xxs flex-between-xxs"
            style={{ gap: 20, width: '100%' }}
          >
            <div
              className="flex-col-md-3 flex-col-sm-12"
              style={{ padding: 0, width: '100%' }}
            >
              <h4 data-intercom-target="customer-notification-copies-heading-notifications-staff-emails">Customer notification copies</h4>
              <span>
                Opt to receive a copy of all email notifications sent to
                customers.
              </span>
            </div>
            <div
              className="flex-col-md-8 flex-col-sm-12"
              style={{ padding: 0, width: '100%' }}
            >
              <div className="ContentPanel">
                <h4 data-intercom-target="customer-notification-recipient-address-heading-notifications-staff-emails">Recipient address</h4>
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ width: '100%', gap: 10 }}
                >
                  <FormItem {...formItemLayout} name="notificationAdminCopyEmailAddress" initialValue={this.state.notificationAdminCopyEmailAddress}>
                    <Input
                      style={{ width: '100%' }}
                      placeholder="Enter an email address"
                      onChange={this.onChangeEmail.bind(this)}
                      value={this.state.notificationAdminCopyEmailAddress}
                      disabled={
                        this.state && !this.state.notificationAdminCopyEnabled
                      }
                      data-intercom-target="customer-notification-recipient-address-input-notifications-staff-emails"
                    />
                  </FormItem>
                  <FormItem {...formItemLayout} name="notificationAdminCopyEnabled" valuePropName="checked" initialValue={this.state.notificationAdminCopyEnabled}>
                    <Checkbox
                      onChange={this.onChange.bind(this)}
                      data-intercom-target="customer-notification-enabled-checkbox-notifications-staff-emails"
                    >
                      Enable
                    </Checkbox>
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <Divider></Divider>
          <div
            className="flex-row flex-row--noMargin flex-top-xxs flex-between-xxs"
            style={{ gap: 20, width: '100%' }}
          >
            <div
              className="flex-col-md-3 flex-col-sm-12"
              style={{ padding: 0, width: '100%' }}
            >
              <h4 data-intercom-target="error-notification-alerts-heading-notifications-staff-emails">Error notification alerts</h4>
              <span>
                Get notified whenever a label generation error occurs for your
                returns.
              </span>
            </div>
            <div
              className="flex-col-md-8 flex-col-sm-12"
              style={{ padding: 0, width: '100%' }}
            >
              <div className="ContentPanel">
                <h4 data-intercom-target="error-notification-recipient-address-heading-notifications-staff-emails">Recipient address</h4>
                <div
                  className="flex-row flex-row--noMargin"
                  style={{ width: '100%', gap: 10 }}
                >
                  <FormItem {...formItemLayout} name="notificationErrorEmail" initialValue={this.state.notificationErrorEmail}>
                    <Input
                      style={{ width: '100%' }}
                      placeholder="Enter an email address"
                      onChange={this.onChangeEmail.bind(this)}
                      value={this.state.notificationErrorEmail}
                      disabled={
                        this.state && !this.state.notificationErrorEnabled
                      }
                      data-intercom-target="error-notification-recipient-address-input-notifications-staff-emails"
                    />
                  </FormItem>
                  <FormItem {...formItemLayout} name="notificationErrorEnabled" valuePropName="checked" initialValue={this.state.notificationErrorEnabled}>
                    <Checkbox
                      onChange={this.onChange.bind(this)}
                      data-intercom-target="error-notification-enabled-checkbox-notifications-staff-emails"
                    >
                      Enable
                    </Checkbox>
                  </FormItem>
                </div>
              </div>
            </div>
          </div>
          <div
            className="flex-row flex-row--noMargin flex-end-xxs u-marginBottom--lg"
            style={{ marginTop: 10 }}
          >
            <FormItem>
              <Button
                type="primary"
                htmlType="submit"
                disabled={this.state.loading}
                loading={this.state.loading}
                style={{ padding: 'var(--input-padding)' }}
                data-intercom-target="footer-save-changes-button-notifications-staff-emails"
              >
                Save changes
              </Button>
            </FormItem>
          </div>
        </Form>
      </React.Fragment>
    );
  }
}

export default EmailAdmin;
